String.prototype.toJSX = // eslint-disable-line
String.prototype.toJSX || function toJSX() {
  let components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  const parser = require('html-react-parser');

  const parse = typeof parser === 'function' ? parser : parser.default;

  const markToReplace = (str, key) => {
    return components && components[key] ? `<stub>${key}</stub>` : str;
  };

  const template = this.toString().replace(/{([\w.]*)}/g, markToReplace);
  const output = parse(template, {
    replace(node) {
      if (node.type !== 'tag' || node.name !== 'stub' || !node.children || !node.children.length) {
        return node;
      }

      const nameNode = node.children[0];

      if (nameNode.type !== 'text') {
        return node;
      }

      const name = nameNode.data;
      const component = components[name];

      if (!component) {
        return node;
      }

      return component;
    }

  });
  return output;
};